import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Headline,
  HeadlineContainer,
  Wrapper,
  HeadlineImage,
  BodegaLandingScene,
  BodegaImageWrapper,
  BodegaImageContainer,
  BodegaImage,
  HeadingWrapper,
  SubheadingContainer,
  BodegaSubheading,
} from "../styles/components/bodega";
import { BREAKPOINTS } from "../styles/variables/breakpoints";
import {
  SectionFooterContainer,
  SectionFooterLogo,
  SectionFooterTextContainer,
  SectionFooterText,
} from "../styles/components/landing";
import animations from "../animations/animations";

const BodegaLanding = ({ content }) => {
  const wrapperRef = useRef(null);
  const bodegaImageRef = useRef(null);
  const subheadingContainerRef = useRef(null);
  const mmRef = useRef(null);

  const imageContainerRef = useRef(null);
  const leftAnchorRef = useRef(null);
  const rightAnchorRef = useRef(null);

  const [activePage, setActivePage] = useState(false);

  const { mainImage, heading, link } = content || {};

  const handleClick = () => {
    if (activePage) return;

    setActivePage(true);

    const timeline = animations.timeline({
      onComplete: () => {
        window.location.href = link;
        setActivePage(false);
      },
    });

    if (!mmRef.current) return;

    mmRef.current.add(`(max-width: ${BREAKPOINTS.sm - 1}px)`, () => {
      timeline.to(subheadingContainerRef.current, {
        delay: 0.5,
        yPercent: 100,
        opacity: 0,
        duration: 2,
      });
    });
  };

  useEffect(() => {
    if (typeof window === "undefined") return;

    mmRef.current = animations.matchMedia();

    return () => {
      mmRef.current?.revert();
    };
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const img = bodegaImageRef.current;
    const left = leftAnchorRef.current;
    const right = rightAnchorRef.current;
    const wrap = imageContainerRef.current;

    if (subheadingContainerRef.current) {
      mmRef.current.add(`(max-width: ${BREAKPOINTS.sm - 1}px)`, () => {
        animations.set(subheadingContainerRef.current, {
          filter: "blur(3px)",
        });
      });
    }

    if (!img || !left || !right || !wrap) return;

    const update = () => {
      const l = left.getBoundingClientRect();
      const r = right.getBoundingClientRect();
      const w = wrap.getBoundingClientRect();
      const { width, height } = img.getBoundingClientRect();

      const cx = (l.right + r.left) / 2;
      const cy = (l.top + r.top) / 2;

      const localX = cx - w.left;
      const localY = cy - w.top;

      animations.set(img, {
        top: localY - height / 3,
        left: localX - width / 1.95,
      });
    };

    update();

    const ro = new ResizeObserver(update);
    ro.observe(wrapperRef.current);

    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("resize", update);
      ro.disconnect();
    };
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        const timeline = animations.timeline({
          onComplete: () => {
            setActivePage(false);
          },
        });

        if (!mmRef.current) return;

        mmRef.current.add(`(max-width: ${BREAKPOINTS.sm - 1}px)`, () => {
          timeline.to(subheadingContainerRef.current, {
            delay: 0.15,
            yPercent: 0,
            opacity: 1,
            duration: 2,
          });
        });
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      mmRef.current?.revert();
    };
  }, []);

  return (
    <Wrapper ref={wrapperRef}>
      <Container>
        <HeadingWrapper className="bodega-landing-container">
          <HeadlineImage src={heading[0]?.image?.fluid?.src} />
          <HeadlineContainer>
            <Headline ref={leftAnchorRef} $fontColor={content?.color}>
              Trident
            </Headline>
            <BodegaLandingScene />
            <Headline ref={rightAnchorRef} $fontColor={content?.color}>
              & True
            </Headline>
          </HeadlineContainer>
        </HeadingWrapper>
        <BodegaImageWrapper className="bodega-landing-scene">
          <BodegaImageContainer
            ref={imageContainerRef}
            onClick={handleClick}
            className="bodega-landing-image-container"
          >
            <BodegaImage
              ref={bodegaImageRef}
              className="bodega-landing-image"
              src={mainImage?.desktop?.src}
              $desktop
            />
            <BodegaImage src={mainImage?.mobile?.src} $mobile />
            <SubheadingContainer
              ref={subheadingContainerRef}
              className="bodega-subheading"
              $mobile
            >
              <BodegaSubheading $fontColor={content?.color}>
                Stef Dag Cuts The Noise
              </BodegaSubheading>
              <SectionFooterContainer $mobile>
                <SectionFooterLogo src="https://www.datocms-assets.com/40484/1745582565-trident-logo-black.png" />
                <SectionFooterTextContainer>
                  <SectionFooterText>Vibe Check</SectionFooterText>
                  <SectionFooterText>Refresh your rhythm</SectionFooterText>
                </SectionFooterTextContainer>
              </SectionFooterContainer>
            </SubheadingContainer>
          </BodegaImageContainer>
        </BodegaImageWrapper>
        <SubheadingContainer className="bodega-landing-text" $desktop>
          <BodegaSubheading $fontColor={content?.color}>
            Stef Dag Cuts The Noise
          </BodegaSubheading>
        </SubheadingContainer>
      </Container>
    </Wrapper>
  );
};

export default BodegaLanding;
